<template>
  <div>
    <b-row class="m-0">
        <b-col class="p-0">
        <fieldset class="border p-3">
            <legend  class="w-auto bg-facebook px-2 py-1 text-white rounded border h6">DEPENDENTS INFORMATION  <font-awesome-icon icon="plus-circle" class="ml-3 cursor-pointer" @click="dependent_modal=true" /></legend>
                <table class="table table-bordered mt-2 mb-0 table-sm">
                    <thead class="thead-dark">
                        <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Relationship</th>
                            <th scope="col" class="text-center">Date of Birth</th>
                            <th scope="col" class="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody class="bg-white text-dark">
                        <tr v-for="(manpower_dependent, index) in params.form.manpower_dependents">
                            <td>
                                {{manpower_dependent.name}}
                            </td>
                            <td>
                                {{manpower_dependent.relationship}}
                            </td>
                            <td>
                                {{manpower_dependent.dob}}
                            </td>
                            <td class="text-center">
                                <b-button size="sm" variant="danger" @click="deleteDependent(manpower_dependent.id)"><font-awesome-icon icon="minus-circle" /> Remove</b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </fieldset>
        </b-col>
    </b-row>

      <b-modal v-model="dependent_modal" centered size="md" body-class="p-0" :hide-footer="true" :hide-header="true">
          <dependent-form @save="save"/>
      </b-modal>
  </div>
</template>
<script>

    import SwalMixin from "@/views/mixins/Swal.js";
    import DependentForm from './DependentForm.vue';
    import NumberFormatComponent from '@/views/helpers/NumberFormatComponent.vue';
    export default {
        mixins:[SwalMixin],
        components: {NumberFormatComponent,DependentForm},
        props:{
            params: {
                type: Object,
                default: {},
                required: true
            },
        },
        data() {
            return {
                dependent_modal:false
            }
        },
        methods:{
            deleteDependent(id){
                this.swalConfirmDelete((data)=>{
                    if (data.value) {
                        this.is_saving=true;
                        this.axios.delete('maintenance/manpowers/dependents/delete',{ data: {id:id} }).then(response => {
                            this.swalTransactionCompleted();
                            this.is_saving=false;
                            this.$emit('save');
                        }).catch(error => {
                            this.swal_transaction_error_data.text = error.response.data;
                            this.swalRequestError();
                            this.is_saving=false;
                        });
                    }
                });
                
            },
            save(){
                this.$emit('save');
                this.dependent_modal=false;
            },
        }
    }
</script>
